export default [
    {
        path: '/general-settings',
        name: 'general-settings',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Configurações Gerais',
            icon: 'mdi-cog-outline',
            breadcrumbs: [
                { text: 'Painel de controle', disabled: true, href: '/' },
                { text: 'Configurações Gerais', disabled: true, href: '/' },
            ],
        }
    }
]
